var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dd-card"},[_c('iframe',{attrs:{"src":`${_vm.metabaseUrl}/${_vm.type}/${_vm.uuid}?company_id=${_vm.companyUuid}`,"frameborder":"0","width":"100%","height":"500","allowtransparency":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }